/* global React */
const { useState, useEffect, useRef } = React;

// ─── Desborde lateral panel ────────────────────────────────────────────────
function DesbordePanel({ content, mode, onClose, reviews }) {
  // mode: "vsl" or "reviews"
  const [revIdx, setRevIdx] = useState(0);
  const review = reviews[revIdx % reviews.length];

  return (
    <aside className="desborde-content">
      <div className="desborde-head">
        <span className="tag tag-line" style={{ color: "oklch(0.78 0.005 80)" }}>
          {mode === "vsl" ? content.vsl.tag : content.reviews.tag}
        </span>
        <button className="desborde-x" onClick={onClose} aria-label="close">×</button>
      </div>

      {mode === "vsl" && (
        <React.Fragment>
          <div className="desborde-body">
            <div className="vsl-frame">
              <div className="nineteen">
                <div className="vsl-corner mono">9:16 · 1:32 · auto-cc</div>
                <div className="vsl-title mono">{content.vsl.title}</div>
                <div className="vsl-meta">{content.vsl.body}</div>
              </div>
              <button className="play" aria-label="play"></button>
            </div>
          </div>

          <div className="desborde-foot">
            <button className="btn btn--teal" style={{ justifyContent: "center", width: "100%" }}>
              {content.vsl.cta}
            </button>
            <div className="desborde-foot-meta mono">
              <span>cap auto · ES / EN</span>
              <span>0:00 / 1:32</span>
            </div>
          </div>
        </React.Fragment>
      )}

      {mode === "reviews" && (
        <React.Fragment>
          <div className="desborde-body desborde-body--center">
            <div className="desborde-review-count mono">
              {String(revIdx + 1).padStart(2, "0")} / {String(reviews.length).padStart(2, "0")}
            </div>
            <blockquote className="desborde-review-text">
              "{review.text}"
            </blockquote>
            <div className="desborde-review-who mono">
              <div className="who-name">{review.name}</div>
              <div className="who-role">{review.role}</div>
            </div>
          </div>
          <div className="desborde-foot">
            <div className="desborde-nav">
              <button
                className="btn desborde-nav-btn"
                onClick={() => setRevIdx((i) => (i - 1 + reviews.length) % reviews.length)}
              >← prev</button>
              <button
                className="btn desborde-nav-btn"
                onClick={() => setRevIdx((i) => (i + 1) % reviews.length)}
              >next →</button>
            </div>
          </div>
        </React.Fragment>
      )}
    </aside>
  );
}

// ─── The collapsed tab on the right edge ──────────────────────────────────
function DesbordeTab({ label, onClick }) {
  return (
    <button className="desborde-tab" onClick={onClick}>
      <span className="dot"></span>
      {label}
    </button>
  );
}

window.DesbordePanel = DesbordePanel;
window.DesbordeTab = DesbordeTab;
